import "./index.css";
import { Box, Grid2, Typography } from "@mui/material";

const YourJourneyWithUs = () => {
  return (
    <Box className="journey-with-us-img section-divide">
      <Box className="container">
        <Box className="section-header-light align-text-center">
          <Typography variant="h2">Your Journey With Us</Typography>
        </Box>
        <Box className="row padding">
          <Grid2 container columnSpacing={4} rowSpacing={5}>
            <Grid2 size={{ md: 4, sm: 12 }}>
              <Box className="item-offers">
                <Box className="letter-1">
                  <span>01</span>
                </Box>
                <Box className="cont">
                  <Typography variant="h6">Choose Loan Amount</Typography>
                  <p>Select the amount that suits your financial needs. </p>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ md: 4, sm: 12 }}>
              <Box className="item-offers">
                <Box className="letter-1">
                  <span>02 </span>
                </Box>
                <Box className="cont">
                  <Typography variant="h6">Approved Your Loan</Typography>
                  <p>Receive quick approval for your loan application. </p>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ md: 4, sm: 12 }}>
              <Box className="item-offers">
                <Box className="letter-1">
                  <span>03 </span>
                </Box>
                <Box className="cont">
                  <Typography variant="h6">Get Your Cash</Typography>
                  <p>Access your funds promptly after approval. </p>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Box>
  );
};

export default YourJourneyWithUs;
